import {arrays, objects, users} from "@atttomyx/shared-utils";
import {themes} from "@atttomyx/shared-constants";
import {INVENTOR, INVESTOR, RANK_GOLD, TYPE_ADMIN, TYPE_INVENTOR} from "../constants";

export const sanitizeUser = (user) => {
    user.roles = normalizeRoles(user.roles);
    user.settings = sanitizeSettings(user.settings);
};

export const sanitizeProfile = (profile) => {
    profile.settings = sanitizeSettings(profile.settings);
};

const sanitizeSettings = (settings) => {
    const sanitized = settings || {};

    sanitized.theme = objects.defaultIfNullOrUndefined(sanitized.theme, themes.DARK);
    sanitized.type = objects.defaultIfNullOrUndefined(sanitized.type, TYPE_ADMIN);
    sanitized.mode = objects.defaultIfNullOrUndefined(sanitized.mode, TYPE_ADMIN);
    sanitized.rank = objects.defaultIfNullOrUndefined(sanitized.rank, RANK_GOLD);

    return sanitized;
};

export const normalizeRoles = (roles) => {
    const sanitized = roles || [];
    const normalized = users.normalizeRoles(sanitized);

    normalized.investor = arrays.contains(sanitized, INVESTOR);
    normalized.inventor = arrays.contains(sanitized, INVENTOR);

    return normalized;
};

export const getRoles = (type) => {
    const roles = {
        user: true,
        admin: false,
    };

    if (type === TYPE_ADMIN) {
        roles.admin = true;
    }

    return roles;
};

export const getSettings = (settings, type, rank) => {
    const decorated = objects.deepCopy(settings);

    decorated.type = type;

    if (type === TYPE_INVENTOR) {
        decorated.rank = rank;
    }

    return decorated;
};
